<template>
  <div class="weekday-selector">
    <el-checkbox-group
      :size="size"
      v-bind:value="commitmentWeekdaysArray"
      v-on:input="onInput"
      @change="onUpdateWeekdays">
      <el-checkbox-button v-for="day in weekdays" :label="day" :key="'weekday-'+day">{{day}}</el-checkbox-button>
    </el-checkbox-group>
    <div class="weekday-selector-helper">
      <a href="" @click.prevent="commitmentWeekdaysArray = weekdays; onUpdateWeekdays()">all</a>,
      <a href="" @click.prevent="commitmentWeekdaysArray = []; onUpdateWeekdays()">none</a>,
      <a href="" @click.prevent="commitmentWeekdaysArray = weekdays.slice(0,5); onUpdateWeekdays()">weekdays</a>,
      <a href="" @click.prevent="commitmentWeekdaysArray = weekdays.slice(-2); onUpdateWeekdays()">weekend</a>
    </div>
  </div>
</template>

<script>
const weekdays_en = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
// eslint-disable-next-line
const weekdays_de = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

export default {
  props: {
    value: {
      Default: []
    },
    size: {
      Default: 'medium'
    }
  },
  data: () => ({
    emitArray: false,
    commitmentWeekdaysArray: [],
    weekdays: weekdays_en
  }),
  created() {
    if ( Array.isArray(this.value) ) {
      this.emitArray = true;
      this.commitmentWeekdaysArray = this.value;
    } else {
      this.emitArray = false;
      this.parseInput(this.value);
    }
  },
  methods: {
    parseInput(weekdays) {
      this.commitmentWeekdaysArray = [];
      for ( let i = 0; i < weekdays.length; i++) {
        if ( weekdays[i] === 'x' ) {
          this.commitmentWeekdaysArray.push( this.weekdays[i] )
        }
      }
    },

    generatePatternStr() {
      let str = '';
      for ( let i = 0; i < this.weekdays.length; i++) {
        str += ( this.commitmentWeekdaysArray.includes( this.weekdays[i] ) ) ? 'x' : '-';
      }
      return str;
    },

    onUpdateWeekdays() {
      if ( this.emitArray ) {
        this.$emit('input', this.commitmentWeekdaysArray)
      } else {
        this.$emit('input', this.generatePatternStr())
      }
    },

    onInput($event) {
      this.commitmentWeekdaysArray = $event;
    }
  }
}
</script>

<style>
.weekday-selector {
  /* margin-bottom: 0.5em; */
}
.weekday-selector .el-checkbox-button {
  margin-bottom: 0;
}
.weekday-selector-helper {
  font-size: 9pt;
}
.weekday-selector .el-checkbox-button__inner {
  padding: 7px 7px;
}
</style>
